import { BaseResponse } from 'app/response/internal/baseresponse';


export class TxnValidResult extends BaseResponse {
    data?: Array<TxnValidData>;
}

export class TxnValidData {
    code: string;
    type: string;
    reason: string;
    sum: string;
    cnt: string;
    limit: string;
    policy_action: string;
}


// WEBPACK FOOTER //
// ./src/app/response/txnvalidresult.ts